export default __webpack_public_path__ + "static/media/pos-pro-16.a3e65cb1.jpg";